import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import axios from 'axios';
import auth from '@feathersjs/authentication-client';

let apiUrl = window.__RUNTIME_CONFIG__.REACT_APP_API_URL;
if (apiUrl.substr(-1) === '/') apiUrl = apiUrl.substr(0, apiUrl.length - 1);

export function getRestSercice(url) {
  const token = window.localStorage.getItem('auth');
  const options = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const client = rest(apiUrl).fetch(window.fetch.bind(window), options);
  const service = client.service(url);
  service.timeout = '500000';
  return service;
}

let client = null;

function createClient() {
  const restClient = rest(apiUrl);
  const app = feathers().configure(restClient.axios(axios));
  app.configure(
    auth({
      storageKey: 'auth',
      storage: window.localStorage,
    })
  );
  app.hooks({
    before: {
      all: [
        (context) => {
          const token = window.localStorage.getItem('auth');
          context.params.headers = {
            ...(context.params.headers || {}),
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'multipart/form-data',
          };
          return context;
        },
      ],
    },
  });

  return app;
}

export function getRestClient() {
  if (!client) {
    client = createClient();
  }
  return client;
}

export function getRestService(serviceName) {
  const service = getRestClient().service(serviceName);
  service.timeout = 500000;
  return service;
}

export function resetRestClient() {
  client = null;
}
